type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const FacebookCommentActionIcon = (props: Props) => {
  const {
    width = '20',
    height = '20',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <g transform="scale(-1 1) translate(-24 0)">
        <path
          d="M3 11.5C3 6.81 7.03 3 12 3s9 3.81 9 8.5-4.03 8.5-9 8.5c-1.07 0-2.1-.18-3.05-.5l-3.6 1.95a.5.5 0 0 1-.74-.5l.34-3.45A8.04 8.04 0 0 1 3 11.5z"
          stroke={fillColor}
          strokeWidth="2.2"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default FacebookCommentActionIcon;
